import Vue from 'vue';
import App from './App';
import router from './router';
//Componentes adicionales
import VueSession from 'vue-session';
import VueResource from 'vue-resource';
import VueMaterial from 'vue-material';
import VueMask from 'v-mask';

//Estilos
import 'vue-material/dist/vue-material.css';
import 'node-snackbar/dist/snackbar.css';

//Inicio editor de texto
import wysiwyg from 'vue-wysiwyg';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
Vue.use(wysiwyg, {});
//Fin editor de texto

Vue.use(VueSession)
Vue.use(VueResource)
Vue.use(VueMaterial)
Vue.use(VueMask)

Vue.http.options.root = 'http://api.grupoalarcom.mx/';
Vue.http.options.emulateJSON = true;

Vue.material.registerTheme('default', {
  primary: {
    color: 'blue',
    hue: 'A200'
  },
  accent: {
    color: 'grey',
    hue: '600'
  },
  warn: 'amber',
  danger: 'red'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js